import * as React from 'react';
import { isArray } from 'easit--utils';

interface IInfoBoxProps {
    type?: 'info' | 'error' | 'success' | 'simple' | 'warning';
    headerText?: string;
    messages?: IInfoBoxItem | IInfoBoxItem[];
    removeMargins?: boolean;
    children?: React.ReactNode;
    roleForTest?: string;
    customClass?: string;
}

interface IInfoBoxItem {
    text?: string;
    withIcon?: boolean;
}

export const InfoBox: React.FC<IInfoBoxProps> = (props: IInfoBoxProps) => {
    const { headerText, messages = [], type = 'error', removeMargins } = { ...props }
    const items = isArray(messages) ? messages : [messages];
    const typesMap = {
        'error': { icon: 'fas fa-exclamation error', class: 'error' },
        'success': { icon: 'fa fa-check success', class: 'success' },
        'info': { icon: 'fas fa-exclamation info', class: 'info' },
        'warning': { icon: 'fas fa-exclamation warning', class: 'warning' }
    }
    return (
        <div className={`info-box ${typesMap[type].class} ${removeMargins ? 'no-margin' : ''} ${props.customClass ? props.customClass : ''}`} data-test-role={props.roleForTest}>
            {
                headerText &&
                <React.Fragment>
                    <span className="info-box-header">
                        {headerText}
                    </span> <br />
                </React.Fragment>
            }
            {
                items.map((message, key) =>
                    <div className="info-box-message" key={key}>
                        {
                            message.withIcon &&
                            <span className={`info-box-icon flex-shrink-0 ${typesMap[type].icon}`}></span>
                        }
                        {message.text}
                    </div>
                )
            }
            {props.children}
        </div>
    )
}